import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ClipboardList, BarChart3, Scale, Wallet, Layers } from 'lucide-react';
const modules = [{
  num: 1,
  emoji: '📘',
  icon: BookOpen,
  title: 'Guía Principal Consultorio Organizado',
  desc: 'La guía central del sistema. Los 4 pilares explicados paso a paso: documentación clínica, cobros, documentos legales y ARCA. Con checklists, ejemplos reales y plan de implementación de 7 días.'
}, {
  num: 2,
  emoji: '📋',
  icon: ClipboardList,
  title: 'Pack Completo de Historia Clínica',
  desc: 'Todas las plantillas para documentar correctamente a tus pacientes: fichas de admisión, historia clínica completa, registro de sesiones, evolución mensual, alta terapéutica, derivación y más. Listas para imprimir.'
}, {
  num: 3,
  emoji: '📊',
  icon: BarChart3,
  title: 'Sistema de Control de Honorarios y Obras Sociales',
  desc: 'La planilla anti-caos para saber cuánto cobraste, cuánto te deben y cómo está cada obra social. Con sistema semáforo para detectar pagos pendientes.'
}, {
  num: 4,
  emoji: '⚖️',
  icon: Scale,
  title: 'Pack de Documentos Legales del Consultorio',
  desc: 'Los documentos que te protegen: consentimiento informado, contrato de servicios, política de cancelación, autorización para menores, modelos de informes para obras sociales e instituciones. Listos para hacer firmar.'
}, {
  num: 5,
  emoji: '💰',
  icon: Wallet,
  title: 'Guía Sin Miedo a la ARCA',
  desc: 'La guía fiscal práctica: Monotributo sin tecnicismos, recategorización paso a paso, facturación electrónica, gastos deducibles y calendario fiscal mes a mes.'
}];
export function ModulesSection() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-117">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-118">
        <div className="text-center mb-10" data-id="element-119">
          <span className="inline-flex items-center gap-2 px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#566049] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-120">
            <Layers className="w-4 h-4 text-[#d4a017]" data-id="element-121" />5 Bloques Incluidos
          </span>
          <h2 className="font-heading font-bold text-[#2f3a2c] text-3xl md:text-5xl leading-tight" data-id="element-122">
            Todo el sistema en{' '}
            <span className="italic text-[#6f7a64]" data-id="element-123">
              5 bloques listos para usar
            </span>
          </h2>
        </div>

        <div className="space-y-5" data-id="element-124">
          {modules.map((m, i) => {
          const Icon = m.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex items-start gap-5 bg-white border border-slate-200 rounded-2xl p-6 md:p-7 shadow-sm" data-id="element-125">
                <div className="flex-shrink-0 flex flex-col items-center gap-2" data-id="element-126">
                  <div className="w-14 h-14 rounded-2xl bg-[#f4efe2] border border-amber-100 flex items-center justify-center" data-id="element-127">
                    <Icon className="w-7 h-7 text-[#6f7a64]" aria-hidden="true" data-id="element-128" />
                  </div>
                  <span className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#6f7a64]" data-id="element-129">
                    Bloque {m.num}
                  </span>
                </div>
                <div data-id="element-130">
                  <h3 className="font-heading font-bold text-[#2f3a2c] text-xl md:text-2xl mb-2" data-id="element-131">
                    <span aria-hidden="true" className="mr-1" data-id="element-132">
                      {m.emoji}
                    </span>
                    {m.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-[15px] md:text-base" data-id="element-133">
                    {m.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}